import { MdDone } from "react-icons/md";

export const Snackbar = (props) => {
    setInterval(() => {
        if (props.onClose) {
            props.onClose();
        }
    }, 3000);
    return (
        <div
            id="toast-default"
            className="bottom-3 right-3 absolute items-center w-full max-w-xs p-4 text-body bg-canvas border border-hairline rounded-md shadow-card"
            role="alert"
        >
            <div className="flex flex-row justify-between ms-3 text-body-md text-ink">
                {props.text} {props.successIcon ? <MdDone className="text-signature-forest" /> : null}
            </div>
            {!props.hideCloseButton ? (
                <button
                    type="button"
                    className="absolute right-0 top-0 ms-auto -mx-1.5 -my-1.5 bg-canvas text-muted hover:text-ink rounded-sm p-1.5 hover:bg-surface-soft inline-flex items-center justify-center h-8 w-8"
                    data-dismiss-target="#toast-default"
                    aria-label="Close"
                >
                    <span className="sr-only">Close</span>
                    <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                </button>
            ) : null}
        </div>
    );
};
